import script from "./SignupNoMail.vue?vue&type=script&setup=true&lang=js"
export * from "./SignupNoMail.vue?vue&type=script&setup=true&lang=js"

import "./SignupNoMail.vue?vue&type=style&index=0&id=e2bc6d52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2bc6d52"]])

export default __exports__